
































































































import { Component, Vue } from 'vue-property-decorator'
import moment from 'moment'
import { appList } from '@/apps/open/services/app'
import { getRemarkInfo, changeEmail } from '@/apps/open/services/developer'
import Button from '@/apps/open/components/Button'

import AutoLink from '@/apps/open/components/AutoLink.vue'
import Avatar from '@/apps/open/components/Avatar'
import { IAppInfo } from '@/apps/open/store/modules/app/types'
import { IUserInfo } from '@/apps/open/store/modules/user/types'
import { onRequestError } from '@/apps/open/utils'

@Component({
  components: {
    'auto-link': AutoLink,
    Avatar,
    Button
  },
  methods: {
    moment
  }
})
export default class DeveloperInfo extends Vue {
  trade = ''
  scale = ''

  tabs = [{
    name: '金山文档',
    key: 'kdoc-apps'
  }, {
    name: '金山文档在线编辑',
    key: 'online-edit-service'
  }, {
    name: '金山文档格式转换',
    key: 'doc-conversion-apps'
  }, {
    name: 'WPS AI开放能力',
    key: 'ai-apps'
  }]

  activeKeyName = this.tabs[0].key

  selectedServiceInfo = {}

  isChange:boolean = true

  form:any = {
    email: ''
  }

  emailRules:any = {
    email: [
      { max: 80, message: '不超过80个字符', trigger: ['blur', 'change'] },
      { required: true, message: '请输入正确的邮箱', trigger: 'blur' },
      { type: 'email', message: '请输入正确的邮箱', trigger: ['blur', 'change'] }
    ]
  }

  get userDevelopers () {
    return this.$store.getters['User/userInfo'].developers || []
  }

  get curEnterprise () {
    return this.$store.getters['User/curEnterprise']
  }

  /**
   * 获取用户信息
   * @returns {}
   */
  get userInfo (): IUserInfo {
    return this.$store.getters['User/userInfo']
  }

  get authClass () {
    return this.isPending ? 'authing' : this.isPassed ? 'authed' : 'unauth'
  }

  get authText () {
    return this.isPending ? '认证中' : this.isPassed ? '已认证' : '未认证'
  }

  get isPending () {
    return this.curEnterprise && this.curEnterprise.status === 0
  }

  get isPassed () {
    return this.curEnterprise && this.curEnterprise.status === 1
  }

  get isRejected () {
    return this.curEnterprise && (this.curEnterprise.status === -1 || this.curEnterprise.status === -3)
  }

  get isSupperAdmin () {
    return this.$store.getters['isSuperAdmin']
  }

  get modifyEmail () {
    return this.form.email === ''
  }

  get isPriDocMiddle () {
    return this.$store.getters['isPriDocMiddle']
  }

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  get isPriDocEdit () {
    return this.$store.getters['isPriDocEdit']
  }

  get admin () {
    return this.$store.getters['Admin/superAdminList'][0] || {}
  }

  get users () {
    const userList = this.$store.getters['Admin/generalAdminList']
    // TODO 待优化
    let users = [[...userList.slice(0, 3)]]
    if (userList.length > 3) {
      users = [...users, [...userList.slice(3, 6)]]
    }
    if (userList.length > 6) {
      users = [...users, [...userList.slice(6, 9)]]
    }
    if (userList.length > 9) {
      users = [...users, [...userList.slice(9, 12)]]
    }
    return users
  }

  goAuth () {
    this.$router.push({ name: 'apply-developer' })
  }

  selectTab (tabKey: string) {
    this.activeKeyName = tabKey
    this.$router.replace({ name: tabKey })
  }

  showInput () {
    this.form.email = this.curEnterprise.email
    this.isChange = !this.isChange
  }

  submitForm (formName:string) {
    (this.$refs[formName] as any).validate(async (valid:boolean) => {
      if (valid) {
        try {
          const params = {
            email: this.form.email,
            developer_id: this.curEnterprise.developer_id
          }
          await this.$store.dispatch('User/CHANGE_DEVELOPER_EMAIL', params)
          await this.$store.dispatch('User/GET_USER_INFO')
          const curDeveloper = this.userDevelopers.find((developer: any) => developer.developer_id === this.curEnterprise.developer_id)
          curDeveloper && this.$store.commit('User/SET_CUR_ENTERPRISE', curDeveloper)
          this.$store.dispatch('User/SET_DEVELOPER_LIST', false)
          this.$message.success('修改成功')
          this.isChange = !this.isChange
        } catch (error) {
          onRequestError(error)
        }
      } else {
        return false
      }
    })
  }

  async loadAdminList () {
    try {
      await this.$store.dispatch('Admin/GET_ADMIN_LIST')
    } catch (error) {
      onRequestError(error)
    }
  }

  initActiveKey () {
    this.activeKeyName = this.$route.name as string
  }

  initAppEntryInPri () {
    this.tabs = [{
      name: '金山文档',
      key: 'kdoc-apps'
    }]
  }

  mounted () {
    this.initEventListener()
    this.initActiveKey()
    this.getRemarkInfo()
    this.loadAdminList()
    this.isPrivate && this.initAppEntryInPri()
  }

  getRemarkInfo () {
    getRemarkInfo(this.curEnterprise && this.curEnterprise.developer_id)
      .then((res) => {
        const data = res.data.object
        this.trade = data.trade
        this.scale = data.scale
      })
  }

  updateDeveloperInfo () {
    this.loadAdminList()
    this.getRemarkInfo()
  }

  initEventListener () {
    this.$eventBus.$on('changeEnterprise', this.updateDeveloperInfo)
  }

  beforeDestroy () {
    this.$eventBus.$clear('changeEnterprise', this.updateDeveloperInfo)
  }
}
